module.exports = __webpack_public_path__ + "img/Science-low.a2439426.jpg";